import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  ChangeUserStatusType,
  GetAllFinacUserPayloadType,
} from "../../../commonTypes/authTypes";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import {
  changeUserStatusAction,
  getAllFinacUsersAction,
  resetAuthError,
  resetAuthSuccess,
  resetFinacUsersList,
  resetSession,
  resetTotalUserCount,
  resetUserProfileAllData,
} from "../../../redux/auth";
import useDebounce from "../../../customHooks/useDebounce";
import {
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  SearchBar,
  TableHeader,
  TableLoader,
} from "../../commons";
import UsersTableData from "../Users/UsersTableData";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../commons/ScrollToTop";
import { USERS_HEADERS } from "../../../constant/tableHeadersConstants/allUserClientsConstants/allUserClientHeaders";
import { UserStatusDataType } from "../../../screens/AllUsersAndClients";
import "./Internal.scss";
import { Col, Row } from "reactstrap";
import { SearchIcon } from "../../Icon";
import Filter, { FILTER_STATUS_FORMAT } from "../FilterAndSorting/Filter";
import MultiSelect from "../../commons/MultiSelect";
import { getMasterDataUsersDepartmentAction } from "../../../redux/masterData";
import { GetUsersDepartmentPayloadType } from "../../../commonTypes/masterDataTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import Sorting from "../FilterAndSorting/Sorting";
import { RecruitmentSortingType } from "../../../commonTypes/hrmsTypes";
// import Filter from "../FilterAndSorting/Filter";
type AppProps = {
  fetching: boolean;
  token: string | null;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetError: () => void;
  dispatchResetAuthSuccess: () => void;

  dispatchChangeUserStatusAction: (data: ChangeUserStatusType) => void;
  dispatchResetSession: () => void;

  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  loginData: LoginResponseType;
  history: any;
  dispatchResetUserProfileAllData: () => void;
  dispatchResetUserDetails: () => void;
  dispatchResetTotalUserCount: () => void;
  totalUserCount: string | number;
  allFinacUsersList: any;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  userDepartmentList: any;
  userDepartmentTotalCount: number;
  usersDepartmentFetching: boolean;
};
const InternalUser = ({
  fetching,
  success,
  statusCode,
  token,
  error,
  dispatchResetError,
  dispatchResetAuthSuccess,
  dispatchChangeUserStatusAction,
  dispatchResetSession,
  loginData,
  history,
  dispatchResetUserProfileAllData,
  dispatchResetUserDetails,

  dispatchGetAllFinacUsersAction,
  allFinacUsersList,
  dispatchResetTotalUserCount,
  totalUserCount,
  dispatchGetMasterDataUsersDepartmentAction,
  userDepartmentList,
  userDepartmentTotalCount,
  usersDepartmentFetching,
}: // totalUserCount,
AppProps) => {
  // const totalUserCount = allFinacUsersList?.total_count;
  const persistInternalSearch = history?.location?.state?.userSearchData;

  const [userSearchData, setUserSearchData] = useState<string>(
    persistInternalSearch
  );
  const [clientSearchData, setClientSearchData] = useState<string>("");
  const [userOffset, setUserOffset] = useState(0);
  const [limit, setLimit] = useState(50);
  const [userData, setUserData] = useState<any>([]);
  const [userSearchClear, setUserSearchClear] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
    useState<boolean>(false);

  const [userStatusData, setUserStatusData] = useState<UserStatusDataType>({
    name: "",
    is_active: null,
    user_id: null,
    type: null,
  });
  const persistAllActiveStatus = history?.location?.state?.allActiveStatus;
  const persistDepartmentFilterValue =
    history?.location?.state?.departmentFilterValue;
  const persistEmploymentStatusValue =
    history?.location?.state?.employmentStatusFilterValue;
  const persistSortBy = history?.location?.state?.sortBy;
  let newActiveStatus = persistAllActiveStatus?.join(",")?.toString();
  const [activeStatus, setActiveStatus] = useState<string>(
    newActiveStatus ? newActiveStatus : newActiveStatus === "0" ? "0" : ""
  );
  const [allActiveStatus, setAllActiveStatus] = useState<any>([]);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [usersDepartmentOffset, setUsersDepartmentOffset] = useState<number>(0);
  const [usersDepartmentText, setUsersDepartmentText] = useState<string>("");
  const [finalUsersDepartmentList, setFinalUsersDepartmentList] = useState<any>(
    []
  );
  const [departmentFilterValue, setDepartmentFilterValue] = useState<{
    value: null | string;
    label: string;
  }>({
    value: null,
    label: "Select...",
  });
  const [employmentStatusFilterValue, setEmploymentStatusFilterValue] =
    useState<{
      value: null | string;
      label: string;
    }>({
      value: null,
      label: "Select...",
    });
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [filterCount, setFilterCount] = useState<any>({
    active: "",
    inactive: "",
    department: "",
    employment_status: "",
  });
  const [toggle, setToggle] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState<RecruitmentSortingType>(
    persistSortBy
    ? persistSortBy
    : {
      name: "",
      value: "",
      id: "",
      _id: "",
    }
  )
  const [isAllUsersStatus, setIsAllUsersStatus] = useMenuCheck();

  useEffect(() => {
    setIsAllUsersStatus("Remove All Users Status Column", "menu");
  }, []);

  useEffect(() => {
    if (allActiveStatus?.includes(10)) {
      setActiveStatus("");
    } else {
      setActiveStatus(allActiveStatus.join(","));
    }
  }, [allActiveStatus]);

  useEffect(() => {
    setDepartmentFilterValue(persistDepartmentFilterValue);
    setEmploymentStatusFilterValue(persistEmploymentStatusValue);
    setFilterCount((prev: any) => {
      return {
        ...prev,
        department: {
          value: persistDepartmentFilterValue?.value
            ? persistDepartmentFilterValue?.value
            : "",
          label: persistDepartmentFilterValue?.value
            ? persistDepartmentFilterValue?.label
            : "Select...",
        },
        employment_status: {
          value: persistEmploymentStatusValue?.value
            ? persistEmploymentStatusValue?.value
            : "",
          label: persistEmploymentStatusValue?.value
            ? persistEmploymentStatusValue?.label
            : "Select...",
        },
      };
    });
  }, [persistDepartmentFilterValue, persistEmploymentStatusValue]);

  useEffect(() => {
    if (persistAllActiveStatus?.length > 0) {
      setAllActiveStatus(persistAllActiveStatus);
      setIsMultiSelectPresent(true);
      getData();
    }

    setFilterCount((prev: any) => {
      return {
        ...prev,
        active:
          persistAllActiveStatus?.length === 1
            ? persistAllActiveStatus?.includes(1)
              ? "1"
              : ""
            : persistAllActiveStatus?.includes(1)
            ? "1"
            : "",
        inactive:
          persistAllActiveStatus?.length === 0
            ? persistAllActiveStatus?.includes(0)
              ? "0"
              : ""
            : persistAllActiveStatus?.includes(0)
            ? "0"
            : "",
      };
    });
  }, [persistAllActiveStatus]);

  useEffect(() => {
    setUserData([]);
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetAuthSuccess();
    dispatchResetError();
    dispatchResetUserProfileAllData();
    dispatchResetUserDetails();
    dispatchResetTotalUserCount();
    setIsMultiSelectPresent(false);
    if (userOffset > 0) {
      setUserOffset(0);
    }
  }, []);

  useEffect(() => {
    if (allFinacUsersList?.data?.length === 0) {
      setUserData(allFinacUsersList?.data);
    } else if (userOffset > 0 && userData?.length > 0) {
      setUserData((prv: any) => [...prv, ...allFinacUsersList?.data]);
    } else {
      setUserData(allFinacUsersList?.data);
    }
  }, [allFinacUsersList?.data]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: userSearchData,
        user_type: "stco_users",
        limit,
        offset: userOffset,
        status: activeStatus
          ? activeStatus
          : persistAllActiveStatus?.length === 1
          ? persistAllActiveStatus[0]
          : persistAllActiveStatus?.length === 2
          ? "1,0"
          : "",
        department: departmentFilterValue?.value
          ? departmentFilterValue?.label
          : persistDepartmentFilterValue?.value
          ? persistDepartmentFilterValue?.label
          : "",
        employment_status: employmentStatusFilterValue?.value
          ? employmentStatusFilterValue?.label
          : persistEmploymentStatusValue?.value
          ? persistEmploymentStatusValue?.label
          : "",
        sortBy: sortBy?._id,
        sortingOrder: sortBy?.value,
      };

      if (totalUserCount) {
        if (+totalUserCount > userOffset) {
          dispatchGetAllFinacUsersAction(finalData);
        }
      } else {
        dispatchGetAllFinacUsersAction(finalData);
      }
    }
  }, [userOffset]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        !fetching &&
        userOffset < +totalUserCount &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (allFinacUsersList?.data?.length > 0) {
          if (!fetching && userOffset < +totalUserCount) {
            setUserOffset(userOffset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [allFinacUsersList?.data]);

  useEffect(() => {
    if (userSearchClear) {
      let finalData = {
        token,
        search_term: userSearchData,
        user_type: "stco_users",
        limit,
        offset: 0,
        status: activeStatus
          ? activeStatus
          : persistAllActiveStatus?.length === 1
          ? persistAllActiveStatus[0]
          : persistAllActiveStatus?.length === 2
          ? "1,0"
          : "",
        department: departmentFilterValue?.value
          ? departmentFilterValue?.label
          : persistDepartmentFilterValue?.value
          ? persistDepartmentFilterValue?.label
          : "",
        employment_status: employmentStatusFilterValue?.value
          ? employmentStatusFilterValue?.label
          : persistEmploymentStatusValue?.value
          ? persistEmploymentStatusValue?.label
          : "",
        sortBy: sortBy?._id,
        sortingOrder: sortBy?.value,
      };
      if (userSearchData?.length === 0) {
        dispatchResetUserDetails();
        dispatchGetAllFinacUsersAction(finalData);
        setUserOffset(0);
      }
    }
  }, [userSearchClear, userSearchData]);

  //Department List
  useEffect(() => {
    const finalDepartmentListData = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: `${data?.department_name}`,
      };
    });
    if (usersDepartmentOffset > 0) {
      setFinalUsersDepartmentList([
        ...finalUsersDepartmentList,
        ...finalDepartmentListData,
      ]);
    } else {
      setFinalUsersDepartmentList(finalDepartmentListData);
    }
  }, [userDepartmentList]);

  useEffect(() => {
    if (token && userDepartmentTotalCount) {
      if (usersDepartmentOffset <= +userDepartmentTotalCount) {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [usersDepartmentOffset]);

  const fetchUsersDepartmentNewData = () => {
    const finalData = {
      token,
      status: 1,
      offset: usersDepartmentOffset,
      limit: limit,
      searchValue: usersDepartmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };

  useDebounce(
    () => {
      if (usersDepartmentText) {
        fetchUsersDepartmentNewData();
      } else {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [usersDepartmentText]
  );

  //   Custom debounce hook for search data
  useDebounce(
    () => {
      if (userSearchData) {
        fetchNewData();
      }
    },
    500,
    [userSearchData, clientSearchData]
  );

  const fetchNewData = () => {
    setUserData([]);
    dispatchResetUserDetails();
    dispatchResetTotalUserCount();
    let finalData = {
      token,
      search_term: userSearchData,
      user_type: "stco_users",
      limit,
      offset: 0,
      status: activeStatus
        ? activeStatus
        : persistAllActiveStatus?.length === 1
        ? persistAllActiveStatus[0]
        : persistAllActiveStatus?.length === 2
        ? "1,0"
        : "",
      department: departmentFilterValue?.value
        ? departmentFilterValue?.label
        : persistDepartmentFilterValue?.value
        ? persistDepartmentFilterValue?.label
        : "",
      employment_status: employmentStatusFilterValue?.value
        ? employmentStatusFilterValue?.label
        : persistEmploymentStatusValue?.value
        ? persistEmploymentStatusValue?.label
        : "",
      sortBy: sortBy?._id,
      sortingOrder: sortBy?.value,
    };
    if (token) {
      setUserSearchClear(true);

      if (userOffset === 0) {
        dispatchGetAllFinacUsersAction(finalData);
        setUserOffset(0);
      } else {
        setUserOffset(0);
      }
    }
  };

  // useEffect(() => {
  //   dispatchResetUserDetails();
  //   dispatchResetTotalUserCount();
  //   getData();
  //   setUserOffset(0);
  //   setIsMultiSelectPresent(true);
  //   if (
  //     (isMultiSelectPresent && activeStatus) ||
  //     (isMultiSelectPresent && !activeStatus)
  //   ) {
  //     if (token) {
  //       let finalData = {
  //         token,
  //         search_term: userSearchData,
  //         user_type: "stco_users",
  //         limit,
  //         offset: userOffset,
  //         status: activeStatus
  //           ? activeStatus
  //           : persistAllActiveStatus?.length === 1
  //           ? persistAllActiveStatus[0]
  //           : persistAllActiveStatus?.length === 2
  //           ? "1,0"
  //           : "",
  //       };

  //       dispatchGetAllFinacUsersAction(finalData);
  //     }
  //   }
  // }, [activeStatus]);
  const onClose = (id: any) => {
    delete history?.location?.state?.allActiveStatus;
    const checkPaymentValue = FILTER_STATUS_FORMAT?.find(
      (item: any) => item?._id === id
    );

    if (checkPaymentValue) {
      const removePaymentValue = allActiveStatus?.filter(
        (item: any) => item != checkPaymentValue?.value
      );
      setAllActiveStatus([...removePaymentValue]);
    }
  };

  const handleSearchUser = (e: any) => {
    setUserSearchData(e.target.value);
  };

  const handleShowConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };
  const handleSetUserStatusChangeData = (data: UserStatusDataType) => {
    setUserStatusData(data);
  };

  const handleChangeUserStatus = () => {
    if (token && userStatusData?.user_id) {
      let finalData: ChangeUserStatusType = {
        token,
        user_id: userStatusData?.user_id,
        status: userStatusData?.is_active === 0 ? 1 : 0,
      };
      dispatchChangeUserStatusAction(finalData);
      setUserSearchData("");
    }
  };
  // const handleToggleChange = () => {
  //   setToggle(!toggle)
  // }

  const handleSorting = (data: any) => {
    setSortBy(data);
    setUserData([]);
    setUserOffset(0);
    dispatchResetUserDetails();

    if (token) {
      let finalData = {
        token,
        search_term: userSearchData,
        user_type: "stco_users",
        limit,
        offset: 0,
        status: activeStatus
          ? activeStatus
          : persistAllActiveStatus?.length === 1
          ? persistAllActiveStatus[0]
          : persistAllActiveStatus?.length === 2
          ? "1,0"
          : "",
        department: departmentFilterValue?.value
          ? departmentFilterValue?.label
          : persistDepartmentFilterValue?.value
          ? persistDepartmentFilterValue?.label
          : "",
        employment_status: employmentStatusFilterValue?.value
          ? employmentStatusFilterValue?.label
          : persistEmploymentStatusValue?.value
          ? persistEmploymentStatusValue?.label
          : "",
        sortBy: data?._id,
        sortingOrder: data?.value,
      };
      dispatchGetAllFinacUsersAction(finalData);
    }
  }

  const getData = useCallback(() => {
    const getPaymentValue = FILTER_STATUS_FORMAT?.filter(
      (el: any, index: number) => {
        if (allActiveStatus?.includes(+el.value) && el?.value != 10) {
          return el;
        }
      }
    );

    if (getPaymentValue?.length === 0) {
      setMultiSelectData([undefined]);
    } else {
      let allStatusValues = allActiveStatus?.includes(10);
      if (allStatusValues) {
        setMultiSelectData([]);
      } else {
        setMultiSelectData([...getPaymentValue]);
      }
    }
  }, [activeStatus]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`${"User"} ${
            userStatusData?.is_active === 0 ? "Enabled" : "Disabled"
          } Successfully!`}
          buttonText="OK"
          onPress={() => {
            if (token) {
              dispatchResetUserDetails();
              // setUserOffset(0)
              setUserSearchData("");
              window.scrollTo(0, 0);
              setUserStatusData({
                name: "",
                user_id: null,
                is_active: null,
                type: null,
              });
              if (userOffset === 0) {
                if (token) {
                  let finalData = {
                    token,
                    search_term: userSearchData,
                    user_type: "stco_users",
                    limit,
                    offset: 0,
                    status: activeStatus
                      ? activeStatus
                      : persistAllActiveStatus?.length === 1
                      ? persistAllActiveStatus[0]
                      : persistAllActiveStatus?.length === 2
                      ? "1,0"
                      : "",
                    department: departmentFilterValue?.value
                      ? departmentFilterValue?.label
                      : persistDepartmentFilterValue?.value
                      ? persistDepartmentFilterValue?.label
                      : "",
                    employment_status: employmentStatusFilterValue?.value
                      ? employmentStatusFilterValue?.label
                      : persistEmploymentStatusValue?.value
                      ? persistEmploymentStatusValue?.label
                      : "",
                    sortBy: sortBy?._id,
                    sortingOrder: sortBy?.value,
                  };
                  dispatchGetAllFinacUsersAction(finalData);
                }
              } else {
                setUserOffset(0);
              }
            }
            dispatchResetAuthSuccess();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  const checkUsersDepartmentBottom = () => {
    setUsersDepartmentOffset((prv: any) => prv + limit);
  };

  const handleApplyFilter = () => {
    setUserOffset(0);
    dispatchResetUserDetails();
    setApplyFilter(true);
    setFilterCount({
      department: {
        value: departmentFilterValue?.value ? departmentFilterValue?.value : "",
        label: departmentFilterValue?.value
          ? departmentFilterValue?.label
          : "Select...",
      },
      employment_status: {
        value: employmentStatusFilterValue?.value
          ? employmentStatusFilterValue?.value
          : "",
        label: employmentStatusFilterValue?.value
          ? employmentStatusFilterValue?.label
          : "Select...",
      },
      active:
        activeStatus?.length === 1
          ? activeStatus === "1"
            ? "1"
            : ""
          : activeStatus?.includes("1")
          ? "1"
          : "",
      inactive:
        activeStatus?.length === 0
          ? activeStatus === "0"
            ? "0"
            : ""
          : activeStatus?.includes("0")
          ? "0"
          : "",
    });
    if (token) {
      let finalData = {
        token,
        search_term: userSearchData,
        user_type: "stco_users",
        limit,
        offset: 0,
        status: activeStatus
          ? activeStatus
          : persistAllActiveStatus?.length === 1
          ? persistAllActiveStatus[0]
          : persistAllActiveStatus?.length === 2
          ? "1,0"
          : "",
        department: departmentFilterValue?.value
          ? departmentFilterValue?.label
          : persistDepartmentFilterValue?.value
          ? persistDepartmentFilterValue?.label
          : "",
        employment_status: employmentStatusFilterValue?.value
          ? employmentStatusFilterValue?.label
          : persistEmploymentStatusValue?.value
          ? persistEmploymentStatusValue?.label
          : "",
        sortBy: sortBy?._id,
        sortingOrder: sortBy?.value,
      };
      dispatchGetAllFinacUsersAction(finalData);
    }
  };

  const clearFilter = () => {
    setUserOffset(0);
    dispatchResetUserDetails();
    delete history?.location?.state?.allActiveStatus;
    delete history?.location?.state?.departmentFilterValue;
    delete history?.location?.state?.employmentStatusFilterValue;
    setFilterCount({
      active: "",
      inactive: "",
      department: "",
    });
    setApplyFilter(false);
    setDepartmentFilterValue({
      value: null,
      label: "Select...",
    });
    setEmploymentStatusFilterValue({
      value: null,
      label: "Select...",
    });
    setAllActiveStatus([]);
    setActiveStatus("");
    if (token) {
      let finalData = {
        token,
        search_term: userSearchData,
        user_type: "stco_users",
        limit,
        offset: 0,
        sortBy: sortBy?._id,
        sortingOrder: sortBy?.value,
      };
      dispatchGetAllFinacUsersAction(finalData);
    }
  };

  return (
    <>
      <Row>
        <Col lg={4}>
          <div className="ml-2 pl-2">
            <h6 style={{ margin: 0, fontSize: "18px", fontWeight: 500 }}>
              Internal Users
            </h6>
            {!fetching && (
              <span
                style={{ color: "#7c8db0", fontSize: "13px", fontWeight: 500 }}
              >
                Total {totalUserCount} entries found
              </span>
            )}
          </div>
        </Col>
        <Col
          lg={8}
          className="text-right d-flex flex-row"
          style={{ justifyContent: "flex-end" }}
        >
          <div className="mr-2 w-auto position-relative">
            <span style={{ position: "absolute", top: "8px", left: "13px" }}>
              <SearchIcon />
            </span>
            <input
              className="form-control"
              type="text"
              value={userSearchData}
              placeholder="Search"
              onChange={(e: any) => handleSearchUser(e)}
              style={{ paddingLeft: "35px" }}
            />
          </div>
          <div className="mr-2">
            <Filter
              setAllActiveStatus={setAllActiveStatus}
              allActiveStatus={allActiveStatus}
              type="internal"
              setUsersDepartmentText={setUsersDepartmentText}
              setUsersDepartmentOffset={setUsersDepartmentOffset}
              finalUsersDepartmentList={finalUsersDepartmentList}
              checkUsersDepartmentBottom={checkUsersDepartmentBottom}
              usersDepartmentFetching={usersDepartmentFetching}
              departmentFilterValue={departmentFilterValue}
              employmentStatusFilterValue={employmentStatusFilterValue}
              setDepartmentFilterValue={setDepartmentFilterValue}
              setEmploymentStatusFilterValue={setEmploymentStatusFilterValue}
              handleApplyFilter={handleApplyFilter}
              clearFilter={clearFilter}
              applyFilter={applyFilter}
              filterCount={filterCount}
              isAllUsersStatus={isAllUsersStatus}
            />
          </div>
          <div className="mr-2">
            <Sorting
              setToggle={setToggle}
              toggle={toggle}
              selectedData={
                sortBy?.value
                ? sortBy
                : { name: "Recently Added/Modified First", value: "" }
                }
              handleSorting={handleSorting}
            />
          </div>
        </Col>
      </Row>
      {/* Future Use */}
      {/* <Row>
        <Col lg={12}>
          <div className="ml-2">
            <MultiSelect data={multiSelectData} onClose={onClose} />
          </div>
        </Col>
      </Row> */}
      {fetching && userOffset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={4} />
      ) : userData?.length > 0 ? (
        <div
          className="jobsType"
          style={{ overflow: "scroll", overflowY: "hidden" }}
        >
          <table className="table table-bordered thead-light">
            <thead
              className="sticky-table-header text-start"
              style={{ whiteSpace: "nowrap" }}
            >
              <TableHeader
                tableHeader={USERS_HEADERS?.filter((header: any) =>
                  isAllUsersStatus ? header.value !== "status" : true
                )}
                extraHeader
                // textCenter
              />
            </thead>
            <tbody>
              <UsersTableData
                data={userData}
                tableHeaders={USERS_HEADERS?.filter((header: any) =>
                  isAllUsersStatus ? header.value !== "status" : true
                )}
                handleConfirmationModal={handleShowConfirmationModal}
                handleSetUserStatusChangeData={handleSetUserStatusChangeData}
                loginData={loginData}
                history={history}
                type={"internal-user"}
                allActiveStatus={allActiveStatus}
                userSearchData={userSearchData}
                departmentFilterValue={departmentFilterValue}
                employmentStatusFilterValue={employmentStatusFilterValue}
                sortBy={sortBy}
                // toggle={toggle}
                // setToggle={setToggle}
                // handleToggleChange={handleToggleChange}
              />
              <div style={{ display: fetching ? "none" : "inline" }}>
                <ScrollToTop />
              </div>
              {fetching && userOffset > 0 && <div>{<InfiniteLoader />}</div>}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="mt-5">
          {!fetching && userData?.length === 0 && (
            <EmptyListPage
              title="No Internal Users List Found!"
              imageWidth="30%"
              showLinkButton={false}
              showAddButton={false}
            />
          )}
        </div>
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleShowConfirmationModal();
            setUserStatusData({
              name: "",
              user_id: null,
              is_active: null,
              type: null,
            });
          }}
          isOpen={showConfirmationModal}
          title={`${
            userStatusData?.is_active === 1
              ? `Disable ${
                  userStatusData?.type === "External Users"
                    ? "Client"
                    : "Internal Users"
                }?`
              : `Enable ${
                  userStatusData?.type === "External Users"
                    ? "External Users"
                    : "Internal Users"
                }?`
          }`}
          message={`Are you sure you want to ${
            userStatusData?.is_active === 0
              ? `enable ${userStatusData?.name}`
              : `disable ${userStatusData?.name}`
          }?`}
          confirmButtonText={
            userStatusData?.is_active === 1 ? "Disable" : "Enable"
          }
          onPressConfirm={() => {
            handleChangeUserStatus();
            handleShowConfirmationModal();
          }}
        />
      )}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.auth.fetching,
  success: state.auth.success,
  error: state.auth.error,
  userDetails: state.auth.userDetails,
  statusCode: state.auth.statusCode,
  token: state.auth.token,
  loginData: state.auth.loginData,
  totalUserCount: state.auth.totalUserCount,
  clientDetails: state.auth.clientList,
  totalClientsCount: state.auth.totalClientsCount,
  allFinacUsersList: state.auth.finacUsersList,
  userDepartmentList: state.masterData.userDepartmentList,
  userDepartmentTotalCount: state.masterData.userDepartmentTotalCount,
  usersDepartmentFetching: state.masterData.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchChangeUserStatusAction: (data: ChangeUserStatusType) =>
    dispatch(changeUserStatusAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),

  dispatchResetUserProfileAllData: () => dispatch(resetUserProfileAllData()),
  dispatchResetTotalUserCount: () => dispatch(resetTotalUserCount()),
  dispatchResetUserDetails: () => dispatch(resetFinacUsersList()),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InternalUser);
